import type { ScreenSchema } from './types';

// Same pattern as screen-course-title. managesOwnSectionAudio: true suppresses
// uc-screen's generic watcher; audio is triggered by the GSAP animation callback
// which passes compiled.course.title/subtitle as overrideText.
const esgTitleSchema: ScreenSchema = {
  template: 'esg-title',
  managesOwnSectionAudio: true,
  slots: {
    intro: {
      parts: [
        { field: 'heading', fallback: ['subheading', 'title'] },
        { field: 'text' }
      ]
    }
  }
};

export default esgTitleSchema;
